import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Settings = {
    muted: boolean;
    skipLanding: boolean;
    mute: () => void;
    unmute: () => void;
    setSkipLanding: (skip: boolean) => void;
};

export const useSettings = create<Settings>()(
    persist(
        (set) => ({
            muted: false,
            skipLanding: false,
            mute: () => set({ muted: true }),
            unmute: () => set({ muted: false }),
            setSkipLanding: (skip: boolean) => set({ skipLanding: skip }),
        }),
        {
            name: 'settings-storage', // Key in localStorage
            partialize: (state) => ({ muted: state.muted, skipLanding: state.skipLanding }), // Only persist muted and skipLanding
        },
    ),
);
